import TimelineIconText from './timeline-icon-text'

export default TimelineIconText
